import React from "react";
import TanStackTable from "../table/TanStackTable";

export const TableArea = () => {
  return <TanStackTable />;
};
